import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleModal, toggleSpinner } from 'apps/auth/actions/appAction';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { changeFieldProperty, setNewFields, setNewForm } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import Form from 'apps/auth/components/form-multi/Form';
import { getField } from 'apps/auth/components/form-multi/utils';
import ModalError from 'apps/auth/components/utils/ModalError';
import { CONTACT_SUPPORT_CLICKED, PERSONAL_INFO_SCREEN_CONTINUE_CLICKED, PERSONAL_INFO_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { COUNTRY_OF_RESIDENCE, FLOW } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { DOB } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { BIRTHDAY_CHECK_ACTION, HELP_MOBILE } from 'apps/auth/constants/UrlConstants';
import { DEFAULT_DATE_REGEX, USA_DATE_REGEX } from 'apps/auth/constants/utilsMasks';
import { USA } from 'apps/auth/constants/WellKnownCountries';
import { ERR_WRONG_CODE } from 'apps/auth/constants/WellKnownErrorCodes';
import { useExtra, useForm, usePageMessages } from 'apps/auth/hooks/selectors';

import { PASSCODE_SCREEN } from './constants';
import { changeBirthdayDateFormat } from './utils';

const BirthdayCheck = (props) => {
    const { tellUsAboutYourselfTitle, birthdayPlaceholder, buttonContinue, wrongBirthdayTitle, contactSupport, tryAgain, birthdayCheckHelpButtonTitle } =
        usePageMessages();
    const form = useForm(props.formName);
    const { smsConfirmation, phoneCountry, birthdayCheckHelpButtonLink } = useExtra();

    useEffect(() => {
        amplitude.getInstance().logEvent(PERSONAL_INFO_SCREEN_SHOWN, {
            [FLOW]: DOB,
            [COUNTRY_OF_RESIDENCE]: phoneCountry?.nameEn,
        });
        if (form?.fields) {
            props.setNewFields(props.formName, smsConfirmationToFormFields(smsConfirmation));
        } else {
            props.setNewForm(props.formName, smsConfirmationToFormFields(smsConfirmation));
        }
    }, []);

    useEffect(() => {
        if (form?.fields?.code?.value) {
            changeBirthdayDateFormat(form?.fields.code, props.changeFieldProperty);
        }
    }, [form?.fields?.code?.value]);

    const smsConfirmationToFormFields = (smsConfirmation) => {
        const fields = {};

        fields.objectId = getField('objectId', smsConfirmation.objectId);
        fields.objectType = getField('objectType', smsConfirmation.objectType);
        fields.code = getField('code', '', phoneCountry?.id === USA ? USA_DATE_REGEX : DEFAULT_DATE_REGEX, true, false, birthdayPlaceholder, 'date');

        return fields;
    };

    const openChat = () => {
        amplitude.getInstance().logEvent(CONTACT_SUPPORT_CLICKED, { [FLOW]: DOB });
        props.toggleChat(true);
    };

    const closeModal = () => {
        props.toggleModal(false);
    };

    const submitHandler = (fields, json) => {
        amplitude.getInstance().logEvent(PERSONAL_INFO_SCREEN_CONTINUE_CLICKED, { [FLOW]: DOB });
        if (json?.extra?.createPasscode) {
            props.setScreen(PASSCODE_SCREEN);
        }

        if (json?.errors && json?.errors?.birthdayError) {
            props.toggleModal(
                true,
                <ModalError
                    mainText={wrongBirthdayTitle}
                    primaryButtonCaption={json.errors['birthdayError']['code'] === ERR_WRONG_CODE ? tryAgain : contactSupport}
                    primaryButtonOnClick={json.errors['birthdayError']['code'] === ERR_WRONG_CODE ? closeModal : openChat}
                />,
            );
        }
    };

    return (
        <>
            <HeaderPanel title={tellUsAboutYourselfTitle} />
            <Form
                id="checkbirthday_form_id"
                action={BIRTHDAY_CHECK_ACTION}
                checkNotVisibleField={false}
                formName={props.formName}
                onSubmitHandler={submitHandler}
            >
                {form?.fields?.code && (
                    <Row indent="24px">
                        <InputAutoDetect formName={props.formName} field={form?.fields?.code} country={phoneCountry} />
                    </Row>
                )}
                {birthdayCheckHelpButtonLink && (
                    <Button
                        type={'link'}
                        href={`${HELP_MOBILE}${birthdayCheckHelpButtonLink}`}
                        caption={birthdayCheckHelpButtonTitle}
                        variant="row"
                        negativeMargin
                        onClick={() => props.toggleSpinner(true)}
                    />
                )}
                <FixedBottomPanel isRightAligned>
                    <Button type="submit" raised={true} caption={buttonContinue} />
                </FixedBottomPanel>
            </Form>
        </>
    );
};

export default connect(null, { setNewForm, setNewFields, changeFieldProperty, toggleModal, toggleChat, toggleSpinner })(BirthdayCheck);
